/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const blogSlider = () => {
		const splide = document.querySelectorAll('.js-blogSlider')
		splide.forEach(slide => {
			new Splide(slide, {
				destroy: true,
				type: 'loop',
				autoplay: true,
				interval: 5000,
				speed: 2000,
				perPage: 3,
				perMove: 1,
				pauseOnHover: false,
				pauseOnFocus: false,
				arrows: true,
				pagination: false,
				breakpoints: {
					1024: {
						destroy: false,
						perPage: 1,
						gap: '24px',
					},
				}
			}).mount();
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		blogSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
